import { LotePolicy } from "./LotePolicy";

export const lotePolicy = new LotePolicy()